module.exports = __webpack_public_path__ + "img/6X4.66ca421b.png";